import { AppState } from '../../data/state'
import { store } from '../../store/store'
import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'
import { ICheckoutStepTrackingData } from './models/ICheckoutStepTrackingData'
import { IGoogleData } from './models/IGoogleData'
import {
  getExtras,
  getFunnelRequiredDetails,
  getFunnelStep1Details,
} from './utils'

export function checkoutStepSummary() {
  try {
    const metrics = getMetrics()
    metrics.api.track(
      EventTypes.CHECKOUT_STEP_SUMMARY,
      getCheckoutSummaryDetails(),
    )
  } catch (e) {
    console.error(`Metrics failed because: ${e}`)
  }
}

function getCheckoutSummaryDetails(): ICheckoutStepTrackingData {
  const state: AppState = Object.assign({}, store.getState())
  const { funnelOrder } = state

  const crossSellItems = getExtras(funnelOrder)

  return {
    ...getFunnelRequiredDetails(state),
    ...getFunnelStep1Details(state),
    extras: crossSellItems.map((x: any) => x.name).join(', '),
    step_number: 3,
    step_name: 'checkoutStepSummary',
    items: crossSellItems,
  }
}

export function FacebookCheckoutStepSummary(
  data: ICheckoutStepTrackingData,
): any {
  return {
    value: data.total_value,
    currency: data.currency,
    content_id: data.trip_id,
    content_name: data.trip_type,
    content_category: data.category,
    trip_type: data.trip_type,
    departure_date: data.departure_date,
    people: data.people,
    adults: data.adults,
    children: data.children,
    babies: data.babies,
    step_name: data.step_name,
    step_number: data.step_number,
    destination: data.destination,
    departure_airport: data.departure_airport,
    departure_time: data.departure_time,
    accomodation: data.accomodation,
    days: data.days,
    extras: data.extras,
    country: data.country,
    coupon: data.coupon,
  }
}

export function GoogleCheckoutStepSummary(
  data: ICheckoutStepTrackingData,
): any {
  const gData: IGoogleData = {
    items: [
      {
        id: data.trip_id,
        name: data.trip_type,
        category: data.category,
        price: data.total_value,
        quantity: 1,
        dimension1: data.trip_type,
        dimension2: data.departure_date,
        dimension3: data.people,
        dimension6: data.adults,
        dimension7: data.children,
        dimension8: data.babies,
        dimension9: data.destination,
        dimension10: data.departure_airport,
        dimension11: data.departure_time,
        dimension12: data.accomodation,
        dimension13: data.days,
        dimension14: data.extras,
        dimension16: data.step_name,
        dimension17: data.country,
        dimension18: data.coupon,
        metric1: data.people,
        metric2: data.adults,
        metric3: data.children,
        metric4: data.babies,
        metric5: data.days,
      },
    ],
    coupon: data.coupon,
    currency: data.currency,
    checkout_step: data.step_number,
    checkout_option: data.step_name,
  }
  if (data.items) {
    gData.items.push(...data.items)
  }
  return gData
}
